import React, { useEffect } from "react";
import { IOrg } from "@schema";
import { Match } from "found";

import { page, PageEvents } from "@clockwise/web-commons/src/util/analytics.util";
import { AdminPanelViews } from "./AdminPanel.container";
import { TopNavigation } from "../TopNavigation";

import { useStyles } from "./AdminPanel.styles";
import { AdminPanelSidebar } from "./admin-panel-sidebar";
import { AdminPanelView } from "./admin-panel-view";

import { getPrimaryBillingGroup } from "@util/pricing.util";
import ThreePieceLayout from "@clockwise/web-commons/src/ui/layouts/ThreePieceLayout";

interface IAdminPanelProps {
  match: Match;
  org: IOrg;
  currentView: AdminPanelViews;
  updateCurrentView: (view: AdminPanelViews) => void;
}

export const AdminPanel = ({ org, currentView, updateCurrentView, match }: IAdminPanelProps) => {
  const classes = useStyles();

  useEffect(() => {
    page(PageEvents.ADMIN_PANEL);
  }, []);

  const primaryBillingGroup = getPrimaryBillingGroup(org);

  return (
    <ThreePieceLayout
      topNav={<TopNavigation pageTitle="Admin" />}
      sidebar={
        <AdminPanelSidebar org={org} currentView={currentView} onSelectView={updateCurrentView} />
      }
      pageView={
        <div className={classes.content}>
          <AdminPanelView
            match={match}
            orgRelayId={org.id}
            currentView={currentView}
            primaryBillingGroupId={primaryBillingGroup ? primaryBillingGroup.id : undefined}
          />
        </div>
      }
    />
  );
};
